import "./../styles/main.scss";
import $ from "jquery";
import inView from "in-view";
import L from "leaflet";
import "leaflet-providers";
import Siema from "siema";
import Timer from "./helpers/Timer";
import Plyr from "plyr";
require('simplelightbox');
$(document).ready(function () {
    $('.galleries').each(function (i, e) {
        var $elm = $(e);
        $elm.find('a').simpleLightbox();
    });
    $("article.job").on("click", function (e) {
        var $elm = $(e.currentTarget);
        $elm.toggleClass("open");
        $elm.find(".description").slideToggle(500);
    });
    $("body").on("click", "a[href^='#goto-']", function (e) {
        e.preventDefault();
        var node = $(e.currentTarget).attr("href").replace("goto-", "");
        var posY = $(node).offset().top - $("#main-header").height();
        if (posY >= 0) {
            $.scrollTo(posY, 400);
        }
    });
    $('body').on("click", ".shared-item", function (e) {
        e.preventDefault();
        window.open($(e.currentTarget).attr("href"), "", "width=500,height=350");
    });
    $("body").on("click", "#menu-switcher a", function (e) {
        e.preventDefault();
        $("#nav-main").toggleClass("show-menu");
        $(e.currentTarget).toggleClass("show-menu");
    });
    $("body").on("click", ".goTo", function (e) {
        var elm = $(e.currentTarget).attr("href");
        var posY = $(elm).offset().top - $("#main-header").height();
        $.scrollTo(posY, 400);
    });
    // $('*[data-appear]').css('opacity',0);
    inView.offset(100);
    inView('*[data-appear]')
        .on('enter', function (el) {
        if ($(el).attr('data-appearlater') === void 0)
            $(el).addClass('animated ' + $(el).attr('data-appear'));
    });
    $('*[data-appearlater]').each(function (i, e) {
        var $this = $(e);
        setTimeout(function () {
            $this.addClass('animated ' + $this.attr('data-appear'));
        }, 150 * i);
    });
    if ($("#map").length) {
        // $('.simpleLightbox').simpleLightbox({
        //     nav: false
        // });
        var icon = new L.Icon({
            iconUrl: '/app/themes/spruce/static/gfx/images/pointer.blue.png',
            iconSize: [200, 96],
            iconAnchor: [100, 48],
            popupAnchor: [1, -48],
            shadowSize: [0, 0]
        });
        var map = L.map('map');
        map.setView([parseFloat($("#map").data("lat")), parseFloat($("#map").data("lng"))], 13);
        map.scrollWheelZoom.disable();
        L.tileLayer.provider("CartoDB.Positron").addTo(map);
        map.touchZoom.disable();
        L.marker([parseFloat($("#map").data("lat")), parseFloat($("#map").data("lng"))], { icon: icon }).addTo(map);
    }
    if ($('#player').length) {
        var player = new Plyr("#player");
    }
    function hideNotSelected() {
        var selectors = [];
        if ($("#works .categories a.active").length) {
            ($("#works .categories a.active").each(function (i, e) {
                selectors.push('.' + $(e).attr("data-type"));
            }).promise().done(function () {
                $(".projects > .col:not(" + selectors.join(",") + ")").fadeOut(200);
                $(selectors.join(",")).fadeIn(200);
            }));
        }
        else {
            $('.projects > .col').fadeIn(200);
        }
    }
    $("#works").on("click", ".categories a", function (e) {
        e.preventDefault();
        $(e.currentTarget).toggleClass("active");
        hideNotSelected();
    });
    $('.slider').each(function (i, e) {
        var sliderNode = $(e);
        // const interludeSliderNode = $('#interlude .slider');
        // if (sliderNode.length) {
        var sliderTimer = new Timer(function () {
            slider.next();
        }, 5000);
        var slider = new Siema({
            selector: sliderNode.find('.siema').get(0),
            loop: true,
            duration: 400,
            onInit: function () {
                sliderNode.find('.navigation').children(":nth-child(1)").addClass("active");
                sliderTimer.start();
            },
            onChange: function () {
                var navigation = sliderNode.find(".navigation");
                navigation.find(".active").removeClass("active");
                navigation.children(":nth-child(" + (this.currentSlide + 1) + ")").addClass("active");
            }
        });
        sliderNode.find(".navigation").on("click", "span", function (e) {
            sliderTimer.reset(5000);
            slider.goTo($(e.currentTarget).index());
        });
        sliderNode.hover(function () {
            sliderTimer.stop();
        }, function () {
            sliderTimer.start();
        });
        sliderNode.on("click", ".control a", function (e) {
            var elm = $(e.currentTarget);
            sliderTimer.reset(5000);
            if (elm.parent().hasClass("left")) {
                slider.prev();
            }
            else {
                slider.next();
            }
        });
        // }
    });
});
